import React, { useCallback, useEffect, useRef, useState } from "react";
// interface
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import Loader from "components/Loader";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import LoadingIconWithText from "components/LoadingIconWithText";
import * as url from "../../../api/urls"
import { ucSetConfigValue, setActiveTool } from "../../../redux/actions"
import {
  loadPostTitle

} from "../../../redux/workplace/wpActions";
import { Link } from "react-router-dom";
import classnames from "classnames";
import AppSimpleBar from "components/AppSimpleBar";
import { FixedSizeList as List } from 'react-window';
import FormInput from "components/FormInput";
import TextBox from "components/TextBox";
import { Switch, FormControlLabel } from '@mui/material';
import { HexColorPicker } from 'react-colorful';
import InputColor from 'react-input-color';
import { Autocomplete, TextField } from '@mui/material';
import Select, { components } from 'react-select';
import { MemberRole, tb_WpTagMaster, tb_WpTagMasterMember } from "../../../redux/workplace/wpTypes";
import { Const, TOOLS } from "const";
import axios from 'axios';
import UserAvatar from "components/UserAvatar";
import HelpInfo from "components/HelpInfo";
import { ServiceResponse } from "api";
import BackHeaderIcon from "components/BackHeaderIcon";


interface DataSettingFollowerProps {
  // basicDetails: BasicDetailsTypes;
}
const DataSettingFollower = ({ /*basicDetails*/ }: DataSettingFollowerProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Settings,
    (st) => ({
      activeTool: st.activeTool,
    })
  );
  const { activeTool } = useAppSelector(storeData);
  const isDark = Utils.IsDarkTheme();
  const api = new APIClient();

  interface EmpData {
    userId: number | null;
    displayName2: string | null;
    positionName: string | null;
    abbrName: string | null;
    foreColor: string | null;
    bgColor: string | null;
    pictureUrl: string | null;
    levelDeep: number | null;
    headId1: number | null;
    headName1: string | null;
    headId2: number | null;
    headName2: string | null;
    headId3: number | null;
    headName3: string | null;
    headId4: number | null;
    headName4: string | null;
    headId5: number | null;
    headName5: string | null;
    headId6: number | null;
    headName6: string | null;
    headId7: number | null;
    headName7: string | null;
    following: boolean | null;
  }
  type TYPES = "FOLLOWER" | "ALL";


  const [listEmpFollowing, setListEmpFollowing] = useState<EmpData[]>([]);
  const [listEmpAll, setListEmpAll] = useState<EmpData[]>([]);
  const [filterFollowing, setFilterFollowing] = useState<string>("");
  const [filterAll, setFilterAll] = useState<string>("");

  const fnLoadEmpList = async () => {
    try {
      api.fnPostForm(url.LOAD_EMP_I_FOLLOW, {})
        .then(rs => {
          setListEmpAll(rs);
          // setListEmpFollowing(rs.filter((t: EmpData) => t.following == true));
        })
        .catch(e2 => Utils.HandleException(e2, true));
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  useEffect(() => {
    setListEmpFollowing(listEmpAll.filter((t: EmpData) => t.following == true));
  }, [listEmpAll]);

  useEffect(() => {
    if (activeTool == TOOLS.TAG_WORK_PLACE_FOLLOWER || true /*#DEFINE DEBUG*/) {
      fnLoadEmpList();
    }
  }, [activeTool]);
  // useEffect(() => { console.log('listEmpFollowing:', listEmpFollowing); }, [listEmpFollowing]);
  // useEffect(() => { console.log('listEmpAll:', listEmpAll); }, [listEmpAll]);

  const ContentHead = () => {
    const contentTitle = "ข้อมูล Following";

    return (
      <div className="d-flex align-items-center " style={{ borderBottom: "dashed gray 1px" }}>
        {/* <div className="flex-shrink-0 d-block d-md-none me-2">
          <Link
            to="#"
            onClick={() => dispatch(setActiveTool(null))}
            className={classnames("user-chat-remove text-muted font-size-24 p-2", { "user-chat-remove-dark": isDark })}
          >
            <i className="bx bx-chevron-left align-middle"></i>
          </Link>
        </div> */}
        <BackHeaderIcon headerOf="setting"></BackHeaderIcon>
        <div className="flex-grow-1 overflow-hidden ">
          <div className="d-flex align-items-center">
            <div
              className={classnames("flex-shrink-0", "chat-user-img", "align-self-center", "me-0", "ms-0",)}
            >
              <i className="text-muted me-3 far fa-eye fz-15"></i>
            </div>
            <div className="flex-grow-1 overflow-hidden">
              <h6 className="text-truncate mb-0 font-size-18">
                <Link to="#" className="user-profile-show text-reset">
                  {contentTitle}
                </Link>
                <HelpInfo infos={[
                  "พนักงานที่ระดับติดกับท่าน จะอยู่ใน follow อัตโนมัติ",
                  "ตัวเลขในวงเล็บ คือลำดับ นับจากตัวท่าน (1 = ติดกับท่าน)",
                  "กดที่ปุ่ม ดวงตา เพื่อการติดตาม/ยกเลิกติดตาม"
                ]} />
              </h6>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const Title: React.FC<{ type: TYPES }> = ({ type }) => {
    const text = type == "FOLLOWER" ? "กำลังติดตาม" : "พนักงานทั้งหมด";
    const icon = type == "FOLLOWER" ? "far fa-eye" : "fas fa-user-friends";
    return (
      <div className="btn btn-secondary w-100 mb-2 d-flex justify-content-between align-items-center">
        <span><i className={icon}></i>&nbsp;{text}</span>
        <div>
          <i className="fas fa-redo-alt text-warning" onClick={() => fnLoadEmpList()}></i>
        </div>
      </div>
    )
  }

  const onFilterChange = useCallback((type: TYPES, val: string) => {
    if (type == "ALL") setFilterAll(val);
    else if (type == "FOLLOWER") setFilterFollowing(val);
  }, []);

  //const EmpList: React.FC<{ type: TYPES; onFilterChange: (type: TYPES, val: string) => void }> = React.memo(({ type, onFilterChange }) => {
  const EmpList: React.FC<{
    list: EmpData[];
    onToggle: (userId: number) => void;
    scrollTopRef: React.MutableRefObject<number>;
  }> = ({ list, onToggle, scrollTopRef }) => {

    const scrollRef = useRef<any>(null);

    useEffect(() => {
      if (scrollRef.current && scrollTopRef.current) {
        scrollRef.current.getScrollElement().scrollTop = scrollTopRef.current;
      }
    }, [list]);

    const onToggleIn = (userId: number) => {
      if (scrollRef.current) {
        scrollTopRef.current = scrollRef.current.getScrollElement().scrollTop;
        console.log(scrollTopRef.current);
      }
      onToggle(userId);
    }
    return (
      <>
        {list.length <= 0 ? (<div className="text-center w-100"><i>-- ไม่มีข้อมูล --</i></div>) : (
          <AppSimpleBar style={{ height: "calc(100vh - 170px)" }} scrollRef={scrollRef}>
            <div className="p-2 pe-4">
              {list.map((emp: EmpData, index: number) => (
                <div key={emp.userId} className="d-flex justify-content-between hover">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                      <UserAvatar profileImage={emp.pictureUrl ?? ""} bgColor={emp.bgColor ?? ""} foreColor={emp.foreColor ?? ""} abbrName={emp.abbrName ?? ""} />
                    </div>
                    <div>
                      <div style={{}} className={classnames({ "text-primary": emp.levelDeep == 1 })}>{emp.displayName2}</div>
                      <div className="text-secondary" style={{}}>({emp.levelDeep}) {emp.positionName}
                        {emp.levelDeep == 1 && (<span className="fz-08 ps-1"><i>(ฟีดอัตโนมัติ)</i></span>)}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center fz-12">
                    {(emp.following) ? (<i className="far fa-eye hand text-warning" onClick={(e) => onToggleIn(emp.userId ?? -1)}></i>) : (<i className="far fa-eye-slash hand text-secondary" onClick={(e) => onToggleIn(emp.userId ?? -1)}></i>)}
                  </div>
                </div>
              ))}
            </div>
          </AppSimpleBar >
        )}
      </>
    )
  };

  const fnFilter = (value1: string, value2: string, filter: string): boolean => {
    const combined = `${value1} ${value2}`.toLowerCase(); // normalize for case-insensitive search
    const keywords = filter.trim().toLowerCase().split(/\s+/); // split by spaces and normalize

    return keywords.every(keyword => combined.includes(keyword));
  }
  const listFilterAll = listEmpAll.filter((t: EmpData) => fnFilter(t.displayName2 ?? "", t.positionName ?? "", filterAll));
  const listFilterFollowing = listEmpFollowing.filter((t: EmpData) => fnFilter(t.displayName2 ?? "", t.positionName ?? "", filterFollowing));

  const onToggle = async (userId: number) => {
    try {
      api.fnPostForm(url.TOGGLE_FOLLOWER, { followerId: userId })
        .then((rs: ServiceResponse) => {
          if (rs.success) {
            // update flag display on right
            setListEmpAll((prev: EmpData[]) => {
              // const idx = prev.findIndex((t: EmpData) => t.userId == userId);
              // if (idx >= 0) {
              //   const updated = [...prev];
              //   updated[idx].following = rs.data;
              //   return updated;
              // }
              // return [...prev]
              const idx = prev.findIndex((t: EmpData) => t.userId == userId);
              if (idx >= 0) {
                const updated = [...prev];
                updated[idx] = {
                  ...updated[idx],
                  following: rs.data
                };
                return updated;
              }
              return prev;
            });
          } else {
            alert(rs.message);
          }
        })
        .catch(e2 => Utils.HandleException(e2, true));
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const scrollTopRefFollowing = useRef<number>(0);
  const scrollTopRefAll = useRef<number>(0);

  return (
    <div className="general-right-container">
      {/* <button onClick={fnTest}>test</button> */}
      {/* <div className="p-2"> */}
      <div className="mb-3">
        <ContentHead />
      </div>
      <div className="dsp-container d-flex justify-content-between">
        {/* following */}
        <div style={{ width: "50%" }}>
          <Title type="FOLLOWER" />
          <TextBox placeholder="กรองด้วย ชื่อ/ตำแหน่ง" style={{ /*padding: "4px", marginBottom: "6px" */ }} icon13css="fas fa-search"
            value={filterFollowing}
            onChange={(e) => onFilterChange("FOLLOWER", e.target.value)}
            onEnter13={() => { }}
          />
          <EmpList list={listFilterFollowing} onToggle={onToggle} scrollTopRef={scrollTopRefFollowing} />
        </div>

        {/* under my supervison */}
        <div style={{ width: "50%" }}>
          <Title type="ALL" />
          <TextBox placeholder="กรองด้วย ชื่อ/ตำแหน่ง" style={{ /*padding: "4px", marginBottom: "6px" */ }} icon13css="fas fa-search"
            value={filterAll}
            onChange={(e) => onFilterChange("ALL", e.target.value)}
            onEnter13={() => { }}
          />
          <EmpList list={listFilterAll} onToggle={onToggle} scrollTopRef={scrollTopRefAll} />
        </div>
      </div>
    </div>
  );
};

export default DataSettingFollower;
